module.exports = __webpack_public_path__ + "img/home2.5fbd3e39.png";